import React, { memo } from 'react';
import { GridFooter } from '@mui/x-data-grid-pro';
import { Stack } from '@mui/material';

export const TableFooter = memo(function TableFooter() {
  return (
    <Stack
      direction="row"
      sx={{
        alignItems: 'center',
        justifyContent: 'space-between',
        px: 1,
      }}
    >
      <div />
      <GridFooter />
    </Stack>
  );
});